module.exports = __webpack_public_path__ + "static/media/baseMeme17.03924e6a.jpg";